import { Injectable } from '@angular/core';
import { ConfirmDialogData } from '../components/components/confirm-dialog/confirm-dialog.component';
import { Subject } from 'rxjs';
import { ConfirmDialogService } from './confirm-dialog.service';

@Injectable({
    providedIn: 'root',
})
export class LeavePageService {
    public allowNavigationSubject = new Subject<boolean>();
    public confirmationShown: boolean = false;
    private LeavePageConfirmDialogConfig: ConfirmDialogData = {
        title: $localize`Do you want to leave this page?`,
        description: $localize`Are you sure you want to leave without saving changes?`,
        primaryButton: {
            text: $localize`Leave this page`,
            action: () => {},
        },
        cancelButton: { text: $localize`Stay on this page` },
    };

    constructor(private confirmDialogService: ConfirmDialogService) {}

    public changeLeavePageConfig(config: any) {
        this.LeavePageConfirmDialogConfig = config;
    }

    public resetLeavePageConfig() {
        this.LeavePageConfirmDialogConfig = {
            title: $localize`Do you want to leave this page?`,
            description: $localize`Are you sure you want to leave without saving changes?`,
            primaryButton: {
                text: $localize`Leave this page`,
                action: () => {},
            },
            cancelButton: { text: $localize`Stay on this page` },
        };
    }

    public navigateThroughLeavePageDialog(): Subject<boolean> {
        this.confirmDialogService.showDialog(this.LeavePageConfirmDialogConfig, {
            primaryCallback: () => {
                this.confirmationShown = true;
                this.allowNavigationSubject.next(true);
            },
            cancelCallback: () => {
                this.confirmationShown = false;
                this.allowNavigationSubject.next(false);
            },
        });

        return this.allowNavigationSubject;
    }
}
